import React, { useEffect, useState } from 'react';
import { XIcon } from 'lucide-react';
export function FooterSection() {
  const currentYear = new Date().getFullYear();
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  // Handle ESC key to close modal
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setActiveModal(null);
      }
    };
    if (activeModal) {
      document.addEventListener('keydown', handleKeyDown);
      // Prevent scrolling on body when modal is open
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  }, [activeModal]);
  const closeModal = () => setActiveModal(null);
  return <>
      <footer className="w-full py-12 px-4 bg-brand-slate text-brand-cream/70 text-center" data-id="element-42">
        <div className="max-w-4xl mx-auto" data-id="element-43">
          <p className="text-sm leading-relaxed mb-6 max-w-2xl mx-auto" data-id="element-44">
            Descargo de responsabilidad: Este producto es una herramienta
            educativa de gestión del estrés y la ansiedad. No sustituye el
            consejo médico profesional, diagnóstico o tratamiento. Consulta
            siempre con tu profesional de salud antes de comenzar cualquier
            práctica nueva si tienes condiciones médicas preexistentes.
          </p>

          <div className="flex flex-wrap justify-center gap-4 mb-6 text-sm" data-id="element-45">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-white underline underline-offset-4 transition-colors focus:outline-none focus:ring-2 focus:ring-brand-cream rounded px-1" aria-label="Leer Política de Privacidad" data-id="element-46">
              Política de Privacidad
            </button>
            <span aria-hidden="true" data-id="element-47">•</span>
            <button onClick={() => setActiveModal('terms')} className="hover:text-white underline underline-offset-4 transition-colors focus:outline-none focus:ring-2 focus:ring-brand-cream rounded px-1" aria-label="Leer Términos y Condiciones" data-id="element-48">
              Términos y Condiciones
            </button>
          </div>

          <p className="text-xs" data-id="element-49">
            &copy; {currentYear} Control de Ansiedad. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      {/* Modal Overlay */}
      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={closeModal} role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-50">
          {/* Modal Content Container */}
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col overflow-hidden relative" onClick={e => e.stopPropagation()} // Prevent clicks inside modal from closing it
      data-id="element-51">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-52">
              <h2 id="modal-title" className="text-2xl font-serif font-bold text-brand-slate" data-id="element-53">
                {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h2>
              <button onClick={closeModal} className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-brand-purple" aria-label="Cerrar ventana" data-id="element-54">
                <XIcon className="w-5 h-5" data-id="element-55" />
              </button>
            </div>

            {/* Scrollable Body */}
            <div className="p-6 overflow-y-auto text-left text-brand-navy space-y-6" data-id="element-56">
              {activeModal === 'privacy' && <>
                  <section data-id="element-57">
                    <h3 className="text-lg font-bold mb-2 text-brand-slate" data-id="element-58">
                      1. Recopilación de Datos
                    </h3>
                    <p className="text-sm leading-relaxed" data-id="element-59">
                      Recopilamos la información personal que nos proporcionas
                      voluntariamente al realizar una compra, como tu nombre,
                      dirección de correo electrónico y detalles de pago. Esta
                      información es necesaria para procesar tu pedido y
                      entregarte el producto digital.
                    </p>
                  </section>

                  <section data-id="element-60">
                    <h3 className="text-lg font-bold mb-2 text-brand-slate" data-id="element-61">
                      2. Uso de la Información
                    </h3>
                    <p className="text-sm leading-relaxed" data-id="element-62">
                      Utilizamos tus datos exclusivamente para procesar tus
                      pedidos, enviarte el material adquirido, comunicarnos
                      contigo sobre tu compra y enviarte actualizaciones
                      relevantes sobre el producto.
                    </p>
                  </section>

                  <section data-id="element-63">
                    <h3 className="text-lg font-bold mb-2 text-brand-slate" data-id="element-64">
                      3. Protección de Datos
                    </h3>
                    <p className="text-sm leading-relaxed" data-id="element-65">
                      Implementamos medidas de seguridad técnicas y
                      organizativas para proteger tu información personal contra
                      acceso no autorizado, alteración, divulgación o
                      destrucción. Tus datos de pago son procesados de forma
                      segura a través de pasarelas de pago encriptadas.
                    </p>
                  </section>

                  <section data-id="element-66">
                    <h3 className="text-lg font-bold mb-2 text-brand-slate" data-id="element-67">
                      4. Uso de Cookies
                    </h3>
                    <p className="text-sm leading-relaxed" data-id="element-68">
                      Utilizamos cookies básicas para mejorar tu experiencia de
                      navegación en nuestro sitio web, recordar tus preferencias
                      y analizar el tráfico del sitio de forma anónima.
                    </p>
                  </section>

                  <section data-id="element-69">
                    <h3 className="text-lg font-bold mb-2 text-brand-slate" data-id="element-70">
                      5. Terceros
                    </h3>
                    <p className="text-sm leading-relaxed" data-id="element-71">
                      No vendemos, intercambiamos ni transferimos tu información
                      personal a terceros. Esto no incluye a los procesadores de
                      pago de confianza que nos asisten en la operación de
                      nuestro sitio web, siempre que dichas partes acuerden
                      mantener esta información confidencial.
                    </p>
                  </section>

                  <section data-id="element-72">
                    <h3 className="text-lg font-bold mb-2 text-brand-slate" data-id="element-73">
                      6. Tus Derechos
                    </h3>
                    <p className="text-sm leading-relaxed" data-id="element-74">
                      Tienes derecho a acceder, rectificar, actualizar o
                      solicitar la eliminación de tu información personal en
                      cualquier momento. Para ejercer estos derechos, puedes
                      responder a cualquiera de los correos electrónicos que
                      recibas de nuestra parte.
                    </p>
                  </section>
                </>}

              {activeModal === 'terms' && <>
                  <section data-id="element-75">
                    <h3 className="text-lg font-bold mb-2 text-brand-slate" data-id="element-76">
                      1. Aceptación de los Términos
                    </h3>
                    <p className="text-sm leading-relaxed" data-id="element-77">
                      Al acceder y realizar una compra en este sitio web,
                      aceptas estar sujeto a estos Términos y Condiciones. Si no
                      estás de acuerdo con alguna parte de estos términos, no
                      debes realizar la compra.
                    </p>
                  </section>

                  <section data-id="element-78">
                    <h3 className="text-lg font-bold mb-2 text-brand-slate" data-id="element-79">
                      2. Descripción del Producto
                    </h3>
                    <p className="text-sm leading-relaxed" data-id="element-80">
                      El producto ofrecido es un material educativo digital
                      (guía en formato PDF) diseñado para proporcionar
                      estrategias de manejo del estrés y la ansiedad. No es un
                      producto físico.
                    </p>
                  </section>

                  <section data-id="element-81">
                    <h3 className="text-lg font-bold mb-2 text-brand-slate" data-id="element-82">
                      3. Pago y Acceso
                    </h3>
                    <p className="text-sm leading-relaxed" data-id="element-83">
                      El pago se realiza en una sola exhibición. Una vez
                      procesado el pago de forma exitosa, recibirás acceso
                      inmediato para descargar el producto digital a través de
                      un enlace proporcionado en la página de confirmación y
                      enviado a tu correo electrónico.
                    </p>
                  </section>

                  <section data-id="element-84">
                    <h3 className="text-lg font-bold mb-2 text-brand-slate" data-id="element-85">
                      4. Política de Reembolsos
                    </h3>
                    <p className="text-sm leading-relaxed" data-id="element-86">
                      Debido a la naturaleza digital y descargable del producto,
                      todas las ventas son finales. No se ofrecen reembolsos una
                      vez que el producto ha sido descargado o accedido, a menos
                      que la ley local exija lo contrario.
                    </p>
                  </section>

                  <section data-id="element-87">
                    <h3 className="text-lg font-bold mb-2 text-brand-slate" data-id="element-88">
                      5. Propiedad Intelectual
                    </h3>
                    <p className="text-sm leading-relaxed" data-id="element-89">
                      Todo el contenido del producto digital está protegido por
                      derechos de autor. La compra te otorga una licencia de uso
                      personal, no comercial. Queda estrictamente prohibida la
                      reproducción, distribución, reventa o modificación del
                      material sin autorización expresa.
                    </p>
                  </section>

                  <section data-id="element-90">
                    <h3 className="text-lg font-bold mb-2 text-brand-slate" data-id="element-91">
                      6. Descargo de Responsabilidad
                    </h3>
                    <p className="text-sm leading-relaxed" data-id="element-92">
                      El contenido proporcionado es estrictamente con fines
                      educativos e informativos. No constituye consejo médico,
                      psiquiátrico ni psicológico profesional. Los resultados
                      pueden variar de persona a persona. Siempre debes
                      consultar a un profesional de la salud calificado para
                      cualquier condición médica.
                    </p>
                  </section>

                  <section data-id="element-93">
                    <h3 className="text-lg font-bold mb-2 text-brand-slate" data-id="element-94">
                      7. Limitación de Responsabilidad
                    </h3>
                    <p className="text-sm leading-relaxed" data-id="element-95">
                      En la medida máxima permitida por la ley aplicable, no
                      seremos responsables de ningún daño directo, indirecto,
                      incidental o consecuente que resulte del uso o la
                      incapacidad de usar nuestro producto.
                    </p>
                  </section>

                  <section data-id="element-96">
                    <h3 className="text-lg font-bold mb-2 text-brand-slate" data-id="element-97">
                      8. Modificaciones
                    </h3>
                    <p className="text-sm leading-relaxed" data-id="element-98">
                      Nos reservamos el derecho de modificar estos términos en
                      cualquier momento. Los cambios entrarán en vigor
                      inmediatamente después de su publicación en el sitio web.
                    </p>
                  </section>
                </>}
            </div>

            {/* Footer of Modal */}
            <div className="p-6 border-t border-gray-100 bg-gray-50 rounded-b-2xl flex justify-end" data-id="element-99">
              <button onClick={closeModal} className="px-6 py-2 bg-brand-slate text-white rounded-full font-medium hover:bg-brand-navy transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-slate" data-id="element-100">
                Entendido
              </button>
            </div>
          </div>
        </div>}
    </>;
}